__turbopack_context__.v({
  "description": "configuration-module-scss-module__qWDj2q__description",
  "divider": "configuration-module-scss-module__qWDj2q__divider",
  "heading": "configuration-module-scss-module__qWDj2q__heading",
  "label": "configuration-module-scss-module__qWDj2q__label",
  "list": "configuration-module-scss-module__qWDj2q__list",
  "name": "configuration-module-scss-module__qWDj2q__name",
  "row": "configuration-module-scss-module__qWDj2q__row",
  "warning": "configuration-module-scss-module__qWDj2q__warning",
});
